import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  Button,
  Checkbox,
  message,
  Card,
  Row,
  Col,
  Modal,
} from "antd";
import MerchantAuth from "../../functions/merchant/merchantAuth";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import EyeCursor from "../../components/other/eyeCursor";
import { useLoading } from "../../context/loadingContext";
import GetMerchantData from "functions/merchant/getMerchantData";
import { bg_button, bg_shadow, bg_text } from "constant/css";
import { useMerchant } from "context/merchantContext";
import PasswordResetRequest from "functions/merchant/resetPasswordRequest";
import ResetPasswordRequest from "functions/merchant/resetPasswordRequest";

const MerchantLogin = () => {
  const [form] = Form.useForm();
  const { showLoading, hideLoading } = useLoading();
  const { setPermissions } = useMerchant();
  const [askMailModal, setAskMailModal] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    //if(localStorage.getItem('merchantToken')) navigate('/merchantDashboard')
    const username = localStorage.getItem("merchantUsername");
    if (username) form.setFieldsValue({ username: username });
  }, []);
  const onFinish = async (values) => {
    showLoading();
    //await waitFor(10)
    const result = await MerchantAuth(values);
    hideLoading(false);
    if (result && result.token) {
      localStorage.setItem("merchantToken", result.token);
      axios.defaults.headers.common["Authorization"] = `Bearer ${result.token}`;
      localStorage.setItem("merchantId", result.merchantId);
      if (values.remember)
        localStorage.setItem("merchantUsername", values.username);
      const merchantData = await GetMerchantData(result.merchantId);
      if (merchantData && merchantData.permissions) {
        setPermissions(merchantData.permissions.map((e) => e.id));
      }
      localStorage.setItem("merchantData", JSON.stringify(merchantData));
      navigate("/merchantDashboard");
    } else message.error("Invalid credentials");
    // redirect to merchant dashboard
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };
  const [rotation, setRotation] = useState(180); // Initial rotation angle

  const handleMouseMove = (event) => {
    const eye = document.querySelector(".eye");
    if (eye) {
      const eyeRect = eye.getBoundingClientRect();
      const eyeCenterX = eyeRect.left + eyeRect.width / 2;
      const eyeCenterY = eyeRect.top + eyeRect.height / 2;

      const angleRad = Math.atan2(
        event.clientX - eyeCenterX,
        event.clientY - eyeCenterY
      );
      const angleDeg = angleRad * (180 / Math.PI) * -1 + 180; // Convert rad to degrees and rotate
      setRotation(angleDeg); // Update the rotation state
    }
  };
  const [visible, setVisible] = useState(true);
  const toggleVisibility = (hide) => {
    setVisible(hide);
  };
  const askMail = () => {
    setAskMailModal(true);
  };
  const onFinishEmail = async (values) => {
    showLoading();
    try {
      const response = await ResetPasswordRequest(values);
      if (response) {
        message.success(
          `Нууц үг сэргээх холбоос ${values.email} -рүү илгээгдлээ.`
        );
        setAskMailModal(false);
      } else {
        message.error("Failed to send reset link. Please try again.");
      }
    } catch (error) {
      console.error("Error sending reset link:", error);
      message.error("Failed to send reset link. Please try again.");
    } finally {
      hideLoading(false);
    }
  };
  return (
    <div
      className="move-area"
      onMouseMove={handleMouseMove}
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <Card
        style={{
          minWidth: "400px",
          maxWidth: "500px",
          borderRadius: 20,
          alignSelf: "center",
          margin: "auto",
          padding: "30px",
        }}
        className={`${bg_shadow}`}
      >
        {/* <HeartPulse /> */}
        <div
          style={{
            width: "100%",
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            marginBottom: "20px",
          }}
        >
          <span
            className={`${bg_text} text-4xl text-transparent font-extrabold mb-6 leading-tight`}
            style={{ fontSize: 30 }}
          >
            Мерчант Нэвтрэх
          </span>
          <span
            className={`${bg_text} text-sm text-transparent font-extrabold mb-6 leading-tight`}
          >
            Rapid, Reliable, Rewarding
          </span>
        </div>
        <Form
          name="basic"
          initialValues={{ remember: true }}
          onFinish={onFinish}
          form={form}
          onFinishFailed={onFinishFailed}
          layout="vertical"
        >
          <Form.Item
            label="Нэвтрэх нэр"
            name="username"
            rules={[{ required: true, message: "Please input your username!" }]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Нууц үг"
            name="password"
            rules={[{ required: true, message: "Please input your password!" }]}
          >
            <Input.Password
              visibilityToggle={true}
              iconRender={(visible) => (
                <EyeCursor
                  onClick={toggleVisibility}
                  visible={visible}
                  rotation={rotation}
                />
              )}
            />
          </Form.Item>
          <Row>
            <Col span={12}>
              <Form.Item name="remember" valuePropName="checked">
                <Checkbox>Намайг сана</Checkbox>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item name="remember">
                <span onClick={askMail} className="float-right cursor-pointer">
                  Нууц үг мартсан?
                </span>
              </Form.Item>
            </Col>
          </Row>
          <Row style={{ width: "100%" }}>
            <Col
              span={24}
              style={{
                justifyItems: "center",
                textAlign: "center",
                width: "100%",
              }}
            >
              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  className={`${bg_button}`}
                >
                  Нэвтрэх
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Card>
      <Modal
        title="Нууц үг сэргээх"
        open={askMailModal}
        onCancel={() => setAskMailModal(false)}
        footer={null}
        width={400}
        className="ask-mail-modal"
        destroyOnClose={true}
        centered
        maskClosable={false}
        afterClose={() => setAskMailModal(false)}
      >
        <div>
          <Form onFinish={onFinishEmail}>
            <Form.Item name="email" rules={[{ required: true, type: "email" }]}>
              <Input placeholder="Enter your email" />
            </Form.Item>
            <div className="w-full flex justify-center">
              <Button
                className={`${bg_button}`}
                type="primary"
                htmlType="submit"
              >
                Шинэчлэх холбоос авах
              </Button>
            </div>
          </Form>
        </div>
      </Modal>
    </div>
  );
};

export default MerchantLogin;
